import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { AuthService } from '../auth.service';
import { GenericResponse } from '../../api-interfaces';
import { FuncsService } from 'src/app/shared/funcs.service';

import { AppPaths } from 'src/enums/app-paths';
import { LogService } from 'src/app/shared/log.service';

@Component({
  selector: 'app-lock-identity',
  templateUrl: './lock-identity.component.html',
  styleUrls: ['./lock-identity.component.sass']
})
export class LockIdentityComponent implements OnInit {

  isSpinning: boolean = false;
  lockIdentityForm!: UntypedFormGroup;

  constructor(
    private funcs: FuncsService,
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private logger: LogService
  ) { }

  ngOnInit(): void {

    this.lockIdentityForm = this.fb.group({
      userName: [null, [Validators.required]],
      code: [null, [Validators.required]],
    });
  }

  submitForm(): void {
    for (const i in this.lockIdentityForm.controls) {
      this.lockIdentityForm.controls[i].markAsDirty();
      this.lockIdentityForm.controls[i].updateValueAndValidity();
    }

    let userName: string = this.lockIdentityForm.value["userName"];
    let code: string = this.lockIdentityForm.value["code"];

    if (!userName || !code) {
      return;
    }

    this.isSpinning = true;

    this.authService.lockIdentity(userName, code)
      .subscribe(
        (response: GenericResponse) => {
          if (response["esito"] == "OK") {
            this.logger.log("Response OK");
          }
        },
        (err: any) => { this.isSpinning = false; },
        () => { this.isSpinning = false; }
      );
  }

  getValidationErrorMessage(errors: any): string {
    return this.funcs.getValidationErrorMessage(errors);
  }

  getAuthLink() {
    return [`/${AppPaths.Auth}`];
  }

  getUsernameLostLink() {
    return [`/${AppPaths.Auth}`, AppPaths.UsernameLost];
  }

  getCodeLostLink() {
    return [`/${AppPaths.Auth}`, AppPaths.CodeLost];
  }
}
